export enum MessageType {
    Success,
    Warning,
    Error,
}

export enum MessageViewType {
    AutoDismiss,
    Freeze,
}

export interface ResponseMessage {
    type: MessageType;
    viewType: MessageViewType;
    message: string;
    acknowledgeButtonText?: string;
    onAcknowledgeActionResponse?: () => void;
}

export default ResponseMessage;
